import type { DividersSetByHand } from "@CommonTypes/backend/PspRules";
import type { DividerRuleError } from "@CommonUtils/pog/dividerPolicyValidation";

/**
 * Sets one store shelf by hand, found the way pogger requests number them:
 * bay = `section_num`, shelf = position from the top. Either field, or both;
 * an absent field keeps the row's value.
 */
export const RoutePutInputsMasterFixturesByStoreShelf = "/inputs/master-fixtures/by-store-shelf";

export type PayloadPutInputsMasterFixturesByStoreShelf = {
  merchflowId: number;
  storeCode: string;
  bayNo: number;
  shelfNo: number;
  /** Null clears the override: the shelf follows the flow's divider policy. */
  dividersSetByHand?: DividersSetByHand | null;
  /** The Fixtures page loader (x100): 0 = never, > 0 = always this deep, null = follow the rule. */
  loaderDepth?: number | null;
};

export type ResponsePutInputsMasterFixturesByStoreShelf = {
  masterFixtureId: number;
  dividersSetByHand: DividersSetByHand | null;
  loaderDepth: number | null;
};

/** 400 for a loader depth below 0 or not below the shelf's depth. */
export type ErrorPutInputsMasterFixturesByStoreShelf = DividerRuleError;
